export default __webpack_public_path__ + "c4d87bedb77e8d29709521b3091afaef.png";